define('controllers/editrooms',['require','nicEditlatest'],function (require) {
    require('nicEditlatest');
    return function() {
        window.Description = null;

        window.toggleArea = function() {
            if (!window.Description) {
                window.Description = new nicEditor({ fullPanel: true }).panelInstance('txtDesc', { hasPanel: true });
            } else {
                window.Description.removeInstance('txtDesc');
                window.Description = null;
            }
        }

        var addComboList = new Array();
        var deleteComboList = new Array();

        window.swapValues = function(array1, array2) {
            for (var i = 0; i < array1.length; i++) {
                for (var j = 0; j < array2.length; j++) {
                    if (array1[i] == array2[j]) {
                        //if a value is in both lists, it cancels out and can be taken out of both
                        array1.splice(i, 1);
                        array2.splice(j, 1);
                        i--;
                        break;
                    }
                }
            }
        }

        window.deleteRow = function (obj) {
            var delRow = obj.parentNode.parentNode;
            var tbl = delRow.parentNode.parentNode;
            var rIndex = delRow.sectionRowIndex;

            deleteComboList.push(delRow.cells[0].innerHTML + "|" + delRow.cells[1].innerHTML);

            tbl.deleteRow(rIndex);
        }
        window.addRow = function (content, morecontent, tableID) {
            if (!document.getElementsByTagName) return;
            var table = document.getElementById(tableID);
            var rowCount = table.rows.length;
            var row = table.insertRow(rowCount);

            var cell1 = document.createElement("td");
            var cell2 = document.createElement("td");
            var cell3 = document.createElement("td");

            var textnode1 = document.createTextNode(content);
            var textnode2 = document.createTextNode(morecontent);
            var btnDelete = document.createElement("a");
            btnDelete.innerHTML = "Delete";
            btnDelete.setAttribute("onclick", "deleteRow(this);");
            btnDelete.setAttribute("style", "cursor:pointer;");

            cell1.appendChild(textnode1);
            cell2.appendChild(textnode2);
            cell3.appendChild(btnDelete);
            row.appendChild(cell1);
            row.appendChild(cell2);
            row.appendChild(cell3);
        }

        window.addRateTypeCombo = function() {
            var txtRoomType = document.getElementById('txtRoomType');
            var rateCode = document.getElementsByName('rateCode');
            var existingCombo;
            var rateCodeChecked = false;
            var lblItExists = document.getElementById('lblItExists');
            lblItExists.innerHTML = "";

            for (var i = 0; i < rateCode.length; i++) {
                if (rateCode[i].checked) {
                    rateCodeChecked = true;
                    break;
                }
            }

            if (!rateCodeChecked) {
                lblItExists.innerHTML += "Select a rate code. ";
            }
            if (txtRoomType.value == "") {
                lblItExists.innerHTML += "Provide a Room Type Code. ";
                return false;
            }

            for (var i = 0; i < rateCode.length; i++) {
                if (rateCode[i].checked && txtRoomType.value != "") {
                    existingCombo = false;
                    $('#tblCombos tr').each(function () {
                        if (this.children[0].innerHTML == txtRoomType.value && this.children[1].innerHTML == rateCode[i].value) {
                            existingCombo = true;
                            lblItExists.innerHTML += "<br />The Combo of " + txtRoomType.value + " and " + rateCode[i].value + " already exists.";
                        }
                    });
                    if (!existingCombo) {
                        addComboList.push(txtRoomType.value + "|" + rateCode[i].value);
                        addRow(txtRoomType.value, rateCode[i].value, 'tblCombos');
                    }
                }
            }
        }

        $(function () {
            document.getElementById('btnSave').onclick = function () {
                //alert("Messy Lists\n\nAdd: " + addComboList.join(",") + "\nDelete: " + deleteComboList.join(","));
                swapValues(addComboList, deleteComboList);
                document.getElementById('hdnAddCombos').value = addComboList.join(",");
                document.getElementById('hdnDeleteCombos').value = deleteComboList.join(",");
                //                alert("Swap Bad\n\ndocument.getElementById('hdnAddCombos').value + "\nDelete: " + document.getElementById('hdnDeleteCombos').value);
                //                return false;
            }

            toggleArea();
            document.getElementById('btnToggleRich').onclick = function () {
                toggleArea();
            }
        });
    };
});

